import { render, staticRenderFns } from "./FrameworkUsageChart.vue?vue&type=template&id=4f7d3dc0"
import script from "./FrameworkUsageChart.vue?vue&type=script&lang=js"
export * from "./FrameworkUsageChart.vue?vue&type=script&lang=js"
import style0 from "./FrameworkUsageChart.vue?vue&type=style&index=0&id=4f7d3dc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports